import { useCallback, useEffect, useRef } from "react";

export default function useTimeout(callback, defaultDelay) {
  const callbackRef = useRef(callback);
  const timeoutRef = useRef();

  // Vždy držíme aktuální callback bez restartování timeoutu
  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  const set = useCallback(
    (customDelay) => {
      // Pokud není předán customDelay, použije se defaultDelay
      const finalDelay = customDelay !== undefined ? customDelay : defaultDelay;

      // Vyčistíme předchozí timeout, aby neběžely dva naráz
      timeoutRef.current && clearTimeout(timeoutRef.current);

      //console.log(`${new Date().toISOString()} Nastavuji setTimeout na ${finalDelay} s`);

      timeoutRef.current = setTimeout(() => callbackRef.current(), finalDelay);
    },
    [defaultDelay],
  );

  const clear = useCallback(() => {
    //console.log(`${new Date().toISOString()} Mazu setTimeout `);
    timeoutRef.current && clearTimeout(timeoutRef.current);
  }, []);

  useEffect(() => {
    set();
    return clear;
  }, [defaultDelay, set, clear]);

  const reset = useCallback(
    (newDelay) => {
      clear();
      set(newDelay);
    },
    [clear, set],
  );

  return { reset, clear, set };
}
